import { Popover as ChakraPopover } from "@chakra-ui/react";

export * from "./PopoverContent";
export * from "./PopoverTrigger";
export * from "./PopoverBody";
export * from "./PopoverAnchor";

export const Popover = ChakraPopover;
